export const FigmaIcon = (props: React.ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 10C10 8.61929 11.1193 7.5 12.5 7.5C13.8807 7.5 15 8.61929 15 10C15 11.3807 13.8807 12.5 12.5 12.5C11.1193 12.5 10 11.3807 10 10Z"
        fill="#1ABCFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 15C5 13.6193 6.11929 12.5 7.5 12.5H10V15C10 16.3807 8.88071 17.5 7.5 17.5C6.11929 17.5 5 16.3807 5 15Z"
        fill="#0ACF83"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 2.5V7.5H12.5C13.8807 7.5 15 6.38071 15 5C15 3.61929 13.8807 2.5 12.5 2.5H10Z"
        fill="#FF7262"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 5C5 6.38071 6.11929 7.5 7.5 7.5H10V2.5H7.5C6.11929 2.5 5 3.61929 5 5Z"
        fill="#F24E1E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 10C5 11.3807 6.11929 12.5 7.5 12.5H10V7.5H7.5C6.11929 7.5 5 8.61929 5 10Z"
        fill="#A259FF"
      />
    </svg>
  );
};
